import React from 'react';
import styled from 'styled-components';
import { breakpoint } from '@zocdoc/components/src/grid';
import { MetricsClickable } from '@zocdoc/frontend-metrics';

import Anchor from './Anchor';

const List = styled.ul`
    column-count: ${p => p.columns};
    padding: 3px 0px 1px;

    ${breakpoint.medium} {
        column-count: auto;
    }
`;

const TruncatableAnchor = styled(Anchor)`
    display: inline-block;
    padding: 0;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export default function FilterList({
    filters,
    columns,
    intl,
}) {
    columns = columns || 2;

    return (
        <List columns={columns}>
            {filters.map(filter => {
                const name = filter.localizedName ? intl.formatMessage(filter.localizedName) : filter.name;
                const url = filter.url.id ? intl.formatMessage(filter.url) : filter.url;
                return (
                    <li key={filter.name}>
                        <MetricsClickable
                            action="Click Find A Doctor By Link"
                            element={filter.name}
                        >
                            <TruncatableAnchor
                                data-filter-name={filter.name}
                                data-test={`find-doctor-by-${filter.name}`}
                                href={`${url}`}
                                title={name}
                            >
                                {name}
                            </TruncatableAnchor>
                        </MetricsClickable>
                    </li>
                );
            })}
        </List>
    );
}
